export default "__VITE_ASSET__E0jmNZ3t__"